﻿function changeManufacturer() {
    var manufacturerName = $("#ManufacturerId").val();
    $.get('/vans/section/query?ManufacturerName=' + manufacturerName, function (response) {
        $('[data-van-section-search]').replaceWith(response);
    });
}

function changeModel() {
    var modelName = $("#ModelId").val();
    $("#ModelName").val(modelName);
}

export function setupVanReviews() {
    if ($('[data-van-reviews-section]').length) {
        $(document).on("change", "#ManufacturerId", changeManufacturer);
        $(document).on("change", "#ModelId", changeModel);
        $("#ManufacturerId").trigger("change");
    }
}